module.exports = __webpack_public_path__ + "static/media/crop.8174628d.svg";